import { FiCopy, FiUserPlus } from 'react-icons/fi'
import { IconType } from 'react-icons'
import { AppNotificationType } from '@/shared/hooks/useNotifications'

/**
 * Per-kind styling for the notification feed, shared by the dashboard section
 * and the header bell so both read as one system.
 *
 * Both kinds stay in the blue family — they are the same class of work — but at
 * clearly different depths: the brand navy for teacher access requests, a
 * lighter blue for duplicate accounts.
 */
export type NotificationStyle = {
    label: string
    icon: IconType
    /** Chakra `colorScheme` for the Review button. */
    colorScheme: string
    /** Border / icon accent. */
    accent: string
    /** Unread row background. */
    tint: string
}

export const NOTIFICATION_STYLES: Record<AppNotificationType, NotificationStyle> = {
    'teacher-request': {
        label: 'Teacher requests',
        icon: FiUserPlus,
        colorScheme: 'brand',
        accent: 'brand.400',
        tint: 'brand.50'
    },
    'duplicate-parent': {
        label: 'Duplicate accounts',
        icon: FiCopy,
        colorScheme: 'blue',
        accent: 'blue.400',
        tint: 'blue.50'
    }
}

/** Display order of the groups in the feed. */
export const NOTIFICATION_GROUP_ORDER: AppNotificationType[] = [
    'teacher-request',
    'duplicate-parent'
]
